export default {
    namespaced: true,
    state: {
        labels: {}
    },
    mutations:{
        set_labels(state,labels){
            state.labels = Object.assign({},state.labels,labels)
        }
    },
    actions:{
        fetchLabelsFromDOM(context){
            const el = 'script'
            const type = 'nordlux/labels'

            const DOMlist = document.querySelectorAll(el)

            DOMlist.forEach(DOM => {
                const elemType = DOM.attributes.type
                const typeValue = elemType ? elemType.nodeValue : ''

                if(typeValue === type){
                    const labels = JSON.parse(DOM.childNodes[0].textContent)
                    context.commit('set_labels',labels)
                }

            })
        }
    },
    getters: {
        getLabel: (state) => (requestedLabelKey) => {
                
            const isKeyPresent = !!(requestedLabelKey)

            const matchingLabelValue = state.labels[requestedLabelKey]

            if(!matchingLabelValue){
                console.warn('Missing label: ',requestedLabelKey, matchingLabelValue)
            }

            const returnString = matchingLabelValue ? matchingLabelValue : `[${isKeyPresent ? requestedLabelKey : 'Missing label key'}]`

            return returnString

        }
    }
}